import {useCallback} from 'react';
import {matchPath, useLocation, useSearchParams} from 'react-router-dom';
import {useAppDispatch} from 'store/customer';
import {
    selectedMenuSet,
    setIsRoomPlannerEditing,
} from 'components/customer/RoomPlanner/store/roomPlannerSlice';
import {isMobile} from 'react-device-detect';

export const useProductSaveRedirection = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    const handleRedirection = useCallback(() => {
        const match = matchPath(
            '/v2/job/:jobId/room/:roomId/room-planner',
            location.pathname
        );

        if (match) {
            searchParams.delete('product');
            searchParams.delete('cabinetId');

            setSearchParams(searchParams);

            dispatch(setIsRoomPlannerEditing(false));

            if (isMobile) {
                dispatch(selectedMenuSet(''));
            }

            return true;
        }
    }, [location, searchParams, setSearchParams]);

    return {
        handleRedirection,
    };
};
